export function ShowModal(title: string, htmlDescription: string) {
    $('#modal-details-title').html(title);
    $('#modal-details-body').html(htmlDescription);
    ($("#modal-details") as any).modal({
        keyboard: false,
        show: true
    });
}